export default class db {
    static toSchedule = {
        storePatient(patient) {
            sessionStorage.setItem('to_schedule_patient', JSON.stringify(patient));
            return patient;
        },
        get patient() {
            return JSON.parse(sessionStorage.getItem('to_schedule_patient'));
        },
        storeProfessional(professional) {
            delete professional?.place_logo;
            sessionStorage.setItem('to_schedule_professional', JSON.stringify(professional));
            return professional;
        },
        get professional() {
            try {
                return JSON.parse(sessionStorage.getItem('to_schedule_professional'));
            } catch (error) {
                return this.storeProfessional(null);
            }
        },
        storeAvailabilityTime(availabilityTime) {
            sessionStorage.setItem('to_schedule_availability_time', JSON.stringify(availabilityTime));
            return availabilityTime;
        },
        get availabilityTime() {
            return JSON.parse(sessionStorage.getItem('to_schedule_availability_time'));
        },
        storeInsurance(insurance) {
            delete insurance?.created_at;
            delete insurance?.updated_at;
            delete insurance?.ordering;
            delete insurance?.trading_name;
            delete insurance?.active;
            delete insurance?.nick_name;

            sessionStorage.setItem('to_schedule_insurance', JSON.stringify(insurance));
            return insurance;
        },
        get insurance() {
            return JSON.parse(sessionStorage.getItem('to_schedule_insurance'));
        },
        storePaymentMethod(paymentMethod) {
            delete paymentMethod?.additional_information;
            delete paymentMethod?.allow_first_schedule;

            sessionStorage.setItem('to_schedule_payment_method', JSON.stringify(paymentMethod));
            return paymentMethod;
        },
        get paymentMethod() {
            return JSON.parse(sessionStorage.getItem('to_schedule_payment_method'));
        },
        storePaymentType(paymentType) {
            sessionStorage.setItem('to_schedule_payment_type', JSON.stringify(paymentType));
            return paymentType;
        },
        get paymentType() {
            return JSON.parse(sessionStorage.getItem('to_schedule_payment_type'));
        },
        storeSpecialty(specialty) {
            delete specialty?.spec_details;
            sessionStorage.setItem('to_schedule_specialty', JSON.stringify(specialty));
            return specialty;
        },
        get specialty() {
            return JSON.parse(sessionStorage.getItem('to_schedule_specialty'));
        },
        storeCity(city) {
            delete city?.created_at;
            delete city?.updated_at;

            sessionStorage.setItem('to_schedule_city', city ? JSON.stringify(city) : null);
            return city;
        },
        get city() {
            return JSON.parse(sessionStorage.getItem('to_schedule_city'));
        },
        storeExams(exams) {
            sessionStorage.setItem('to_schedule_exams', exams ? JSON.stringify(exams) : null);
            return exams;
        },
        get exams() {
            return JSON.parse(sessionStorage.getItem('to_schedule_exams'));
        },
        storeCancelingPolicy(cancelingPolicy) {
            sessionStorage.setItem('to_schedule_canceling_policy', JSON.stringify(cancelingPolicy));
            return cancelingPolicy;
        },
        get cancelingPolicy() {
            return JSON.parse(sessionStorage.getItem('to_schedule_canceling_policy'));
        },
        storePixData(pixData) {
            sessionStorage.setItem('to_schedule_pix_data', JSON.stringify(pixData));
            return pixData;
        },
        get pixData() {
            return JSON.parse(sessionStorage.getItem('to_schedule_pix_data'));
        },
        storePlace(pixData) {
            sessionStorage.setItem('to_place', JSON.stringify(pixData));
            return pixData;
        },
        get place() {
            return JSON.parse(sessionStorage.getItem('to_place'));
        },
        storePlaceSchedule(place) {
            delete place?.place_logo;
            sessionStorage.setItem('to_schedule_place', JSON.stringify(place));
            return place;
        },
        get placeSchedule() {
            return JSON.parse(sessionStorage.getItem('to_schedule_place'));
        },
        storeScheduleType(type) {
            sessionStorage.setItem('to_schedule_type', type);
            return type;
        },
        get scheduleType() {
            return sessionStorage.getItem('to_schedule_type');
        },
        storeAttendanceType(type) {
            sessionStorage.setItem('to_schedule_attendance_type', type);
            return type;
        },
        get attendanceType() {
            return sessionStorage.getItem('to_schedule_attendance_type');
        },
        storeSpecGroup(specGroup) {
            sessionStorage.setItem('to_schedule_spec_group', JSON.stringify(specGroup));
            return specGroup;
        },
        get specGroup() {
            return JSON.parse(sessionStorage.getItem('to_schedule_spec_group'));
        },
        storePlan(plan) {
            sessionStorage.setItem('to_schedule_plan', JSON.stringify(plan));
            return plan;
        },
        get plan() {
            return JSON.parse(sessionStorage.getItem('to_schedule_plan'));
        },
        storePatientPlanCPF(cpf) {
            sessionStorage.setItem('to_schedule_patient_plan_cpf', cpf);
            return cpf;
        },
        get patientPlanCPF() {
            return sessionStorage.getItem('to_schedule_patient_plan_cpf');
        },
    }

    static storeToken(token) {
        if (token == null || token === 'null') {
            localStorage.removeItem('token');
        } else {
            localStorage.setItem('token', token);
        }

        return token;
    }
    static get token() {
        let value = localStorage.getItem('token');
        if (value == null || value === 'null') {
            return null;
        }

        return value;
    }
    static storeUser(user) {
        localStorage.setItem('user', JSON.stringify(user));
        return user;
    }
    static get user() {
        return JSON.parse(localStorage.getItem('user'));
    }
}